export const LOCAL_STORAGE_KEYS = {
  API_BASE_URL_OVERRIDE: 'mgrv_api_base_url_override',
  /** web-mesher(FastAPI) 도메인 전용 오버라이드. 메인 API 오버라이드와 서로 영향을 주지 않는다. */
  MESHER_API_BASE_URL_OVERRIDE: 'mgrv_mesher_api_base_url_override',
  /** app-mesher(FastAPI, mgrv-app-mesher) 도메인 전용 오버라이드. web-mesher와 다른 서버다. */
  APP_MESHER_API_BASE_URL_OVERRIDE: 'mgrv_app_mesher_api_base_url_override',
  /** mgrv-shortener(FastAPI) 도메인 전용 오버라이드. */
  SHORTENER_API_BASE_URL_OVERRIDE: 'mgrv_shortener_api_base_url_override',
  /** 관리비 관리(정기청구·퇴실청구·일반관리비 설정)에서 마지막으로 선택한 지점. 세 화면이 공유한다. */
  BILLING_SELECTED_BRANCH_ID: 'billing_selected_branch_id',
  // 런치패드 위저드 전용 인증 (MFMS와 동일 키 — 관리자 세션과 분리 저장)
  LAUNCHPAD_AUTH_TOKEN: 'launchpad_auth_token',
  LAUNCHPAD_USER_INFO: 'launchpad_user_info',
} as const;
